import {
  ClinicInformationState,
  LoadClinicInformationAction,
} from "./type";

export function loadClinicInformationHandler(state: ClinicInformationState, action: LoadClinicInformationAction): ClinicInformationState {
    return Object.assign({}, state, {
        ...action.payload
    });
}



// WEBPACK FOOTER //
// ./src/store/ClinicInformation/handlers.ts